import request from '@/utils/request';

// 查询白名单
export function whiteList(options) {
  return request({
    url: `/op/whiteList/pageList`,
    method: 'get',
    params: options
  });
}

// 添加白名单
export function whiteListAdd(options) {
  return request({
    url: `/op/whiteList/add`,
    method: 'post',
    data: options
  });
}

// 删除白名单
export function whiteListDel(options) {
  return request({
    url: `/op/whiteList/delete/${options.mobile}`,
    method: 'delete'
  });
}
